"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CharTypes;
(function (CharTypes) {
    CharTypes[CharTypes["USER"] = 1] = "USER";
    CharTypes[CharTypes["CHAR"] = 2] = "CHAR";
    CharTypes[CharTypes["MASK"] = 3] = "MASK";
})(CharTypes = exports.CharTypes || (exports.CharTypes = {}));
